
export default function AppCard(props){
    return (
        <div className={`grid rounded-lg
                bg-card dark:bg-card_dark
                text-card dark:text-card_dark 
                shadow-md shadow-gray-600 
                dark:shadow-sky-950 overflow-hidden p-6 `+ props.className
                }>
            {props.children}
        </div>
    )
}
